require('./personeticsRichTeaser.scss');
require('./personeticsRichTeaser.override.scss');

// @ vendor
const { connect } = require('react-redux');
const classnames = require('classnames');
const moment = require('moment');
const PropTypes = require('prop-types');
const React = require('react');
const { withRouter } = require('react-router-dom');
import PersoneticsWidget from 'personetics';

// @commons
const { Accordion } = require('commonsComponents/accordion');
const { AccordionBody } = require('commonsComponents/accordionBody');
const { AccordionHeader } = require('commonsComponents/accordionHeader');
const { LoadingSection } = require('commonsComponents/loadingSection');
const OKTag = require('commonsComponents/OKTag');
const { OKButton } = require('components/commons/OKButton/OKButton');
const { EmptyState } = require('commonsComponents/emptyState');
const { formatText, FormattedText, getLanguage } = require('core/i18n').i18n;

// @actions
const accountsTransactionsActions = require('actions/getAccountsTransactions');

// @utilities
const PersoneticsNavigation = require('utilities/personeticsNavigation');
const { hash } = require('utilities/hash');
const { recordProcess, recordLinkV2 } = require('utilities/tagging');

// @constants
const {
    ACCOUNT_DEFER_PAYMENT_NAVIGATION,
    ACCOUNT_MOVEMENT_NAVIGATION,
    CARD_MOVEMENT_NAVIGATION,
    EMITED_TRANSFER_MOVEMENT_NAVIGATION,
    NEW_TAB_CTA_LINKS,
} = require('constants/personeticsLinks');
const { PERSONETICS_EVENT_CATEGORY,PERSONETICS_INBOX_EVENT_CATEGORY } = require('constants/tagging');

// @components
const PersoneticsBarChart = require('./personeticsBarChart');
const PersoneticsHorizontalBarChart = require('./personeticsHorizontalBarChart');
const PersoneticsPieChart = require('./personeticsPieChart');
const PersoneticsPinChart = require('./personeticsPinChart');
const PersoneticsLineChart = require('./personeticsLineChart');

class PersoneticsRichTeaser extends React.Component {
    constructor(props) {
        super(props);
        this.getAccountId = this.getAccountId.bind(this);
        this.getCardId = this.getCardId.bind(this);
        this.getMovementId = this.getMovementId.bind(this);
        this.handleEventsTagging = this.handleEventsTagging.bind(this);
        this.handleOnClick = this.handleOnClick.bind(this);
        this.persoWidget = React.createRef();
        this.widgetConfig = PersoneticsWidget.defaultConfig;
        this.widgetConfig.eventHandler = this.handlePersoneticsEvents.bind(
            this
        );
        this.widgetConfig.widgetType = PersoneticsWidget.wTypes.STORY_WIDGET;
        this.widgetConfig.lang = getLanguage();
        this.state = {
            accountId: null,
            cardId: null,
            expandedId: '',
            navigateTarget: '',
            navigationData: {},
            widgetConfig: this.widgetConfig,
        };
    }

    componentDidMount() {
        const element = document.getElementById(
            `sec_accordion_${this.props.clickedId}`
        );
        element && window.scrollTo(0, element.offsetTop + 100);
        window.addEventListener('resize', () => this.forceUpdate());
        if (this.props.clickedId && !this.state.expandedId) {
            this.setState({ expandedId: this.props.clickedId });
        }
        const allProductDetails = this.getAllProductDetails();
        recordProcess(PERSONETICS_INBOX_EVENT_CATEGORY, '', allProductDetails, true);
    }

    componentDidUpdate() {
        const { history, immTransaction } = this.props;
        if (
            this.state.navigateTarget === ACCOUNT_DEFER_PAYMENT_NAVIGATION &&
            !!immTransaction.getIn([this.state.accountId, 'byId'])
        ) {
            const movementId = this.getMovementId(
                this.state.navigationData,
                this.state.accountId
            );
            if (movementId) {
                PersoneticsNavigation.getNavigation(
                    this.state.navigateTarget,
                    this.state.accountId,
                    this.state.cardId,
                    movementId,
                    history
                );
            }
        }
    }

    componentWillUnmount() {
        window.removeEventListener('resize', () => this.forceUpdate());
    }

    handleEventsTagging(taggingData, id) {
        let eventAction;
        const currentProductDetails = this.getCurrentProduct(id)[0];
        delete currentProductDetails.teaser_id;
        if (taggingData.hasOwnProperty('additionalData')) {
            switch (taggingData.eventId) {
                case 'pie-chart-tab-click':
                    let eventLabelCard = taggingData.additionalData['tab-clicked'] === 'inflows' ? 'ingresos':'gastos';
                    if (taggingData.additionalData['tab-clicked']) {
                        eventAction = `cambiar a ${eventLabelCard}`;
                    } else if (taggingData.additionalData['button-clicked']) {
                        eventAction = `ir a ${eventLabelCard}`;
                    } else if (taggingData.additionalData['quiz-answer']) {
                        eventAction = eventLabelCard;
                    } else if (taggingData.additionalData['value']) {
                        eventAction = eventLabelCard;
                    }
                    break;
                case 'account-selector-tab-clicked':
                    let eventLabelAccountSelector;
                    if (
                        taggingData.additionalData['tab-clicked'] ===
                        'all accounts'
                    ) {
                        eventLabelAccountSelector = 'todas las cuentas';
                    } else if (
                        taggingData.additionalData['tab-clicked'] ===
                        'choose account'
                    ) {
                        eventLabelAccountSelector = 'eligir cuentas';
                    }
                    if (taggingData.additionalData['tab-clicked']) {
                        eventAction = `cambiar a ${eventLabelAccountSelector}`;
                    } else if (taggingData.additionalData['button-clicked']) {
                       eventAction = `ir a ${eventLabelAccountSelector}`;
                    } else if (taggingData.additionalData['quiz-answer']) {
                        eventAction = eventLabelAccountSelector;
                    } else if (taggingData.additionalData['value']) {
                        eventAction = eventLabelAccountSelector;
                    }
                    break;
                case 'rating-click':
                    let eventLabelCardRead = taggingData.eventId;
                    if (taggingData.additionalData['tab-clicked']) {
                        eventAction = `cambiar a ${eventLabelCardRead}`;
                    } else if (taggingData.additionalData['button-clicked']) {
                        eventAction = `ir a ${eventLabelCardRead}`;
                    } else if (taggingData.additionalData['quiz-answer']) {
                        eventAction = '';
                    } else if (taggingData.additionalData['value']) {
                        eventAction = taggingData.additionalData['value'] === '4'
                        ? 'utilidad si'
                        : 'utilidad no';
                    }
                    break;
                    case 'primary-button-click':
                    if (taggingData.additionalData['tab-clicked']) {
                        eventAction = `cambiar a ${currentProductDetails.product_name}`;
                    } else if (taggingData.additionalData['button-clicked']) {
                        eventAction = `ver detalle`;
                    } else if (taggingData.additionalData['quiz-answer']) {
                        eventAction = '';
                    } else if (taggingData.additionalData['value']) {
                        eventAction =  taggingData.additionalData['value'] === '4'
                        ? 'utilidad si'
                        : 'utilidad no';
                    }
                    break;

            }
        } else {
            if (taggingData.eventId === 'account-switch') {
                eventAction = `cambiar cuenta`;
            } else if (taggingData.eventId === 'pie-chart-arrow-click') {
                eventAction = `cambiar categoria`;
            }
        }
        const analyticsData = {
            categoriaEvento: PERSONETICS_EVENT_CATEGORY,
            accionEvento: eventAction,
            etiquetaEvento: currentProductDetails.product_name,
            zonaInicio: PERSONETICS_INBOX_EVENT_CATEGORY,
            ...currentProductDetails,
        };
        recordLinkV2(analyticsData);
    }

    handleOnClick = (isExpanded, id) => {
        const { getPersoneticsInsightDetails } = this.props;

        getPersoneticsInsightDetails(id);
        this.setState({
            expandedId: isExpanded ? id : '',
        });
        const currentProductDetails = this.getCurrentProduct(id)[0];
        delete currentProductDetails.teaser_id;
        const eventAction = isExpanded ? 'chevron open' : 'chevron close';
        const analyticsData = {
            categoriaEvento: PERSONETICS_EVENT_CATEGORY,
            accionEvento: eventAction,
            etiquetaEvento: currentProductDetails.product_name,
            zonaInicio: PERSONETICS_INBOX_EVENT_CATEGORY,
            ...currentProductDetails,
        };
        recordLinkV2(analyticsData);
    };

    getAccountId(navigationData) {
        const { immAccounts } = this.props;
        const immAccountsById = immAccounts.get('byId');
        const immAccountsByOrder = immAccounts.get('byOrder');
        const selectedAccountId = immAccountsByOrder.find((accountId) => {
            const immAccount = immAccountsById.get(accountId);
            let compareValue = navigationData.contractNumber;
            if ((navigationData.contractNumber || '').includes('_')) {
                compareValue =
                    immAccount.get('newContractNumber') +
                    '_' +
                    immAccount.get('newProduct');
            }
            return compareValue === navigationData.contractNumber;
        });
        return selectedAccountId;
    }

    getCardId(navigationData) {
        const { immCards } = this.props;
        const immCardsById = immCards.get('byId');
        const immCardsByOrder = immCards.get('byOrder');
        const selectedCardId = immCardsByOrder.find((cardId) => {
            const immCard = immCardsById.get(cardId);
            let compareValue = navigationData.contractNumber;
            if ((navigationData.contractNumber || '').includes('_')) {
                compareValue =
                    immCard.getIn(['contract', 'number']) +
                    '_' +
                    immCard.getIn(['contract', 'product']);
            }
            return compareValue === navigationData.contractNumber;
        });
        return selectedCardId;
    }

    getMovementId(navigationData, accountId) {
        const { immTransaction } = this.props;
        const transactions = immTransaction.getIn([accountId, 'byId']);
        const movement =
            transactions &&
            transactions.valueSeq().find((transaction) => {
                return (
                    transaction.getIn(['balance', 'amount']) ===
                        navigationData.amount &&
                    transaction.get('date') === navigationData.date &&
                    transaction.get('description') ===
                        navigationData.description
                );
            });
        let movementId = null;
        if (movement) {
            movementId = hash([
                movement.getIn(['extra', 'movementNumber']),
                movement.get('date'),
                movement.get('description'),
                movement.getIn(['balance', 'amount']),
                movement.getIn(['totalBalance', 'amount']),
                movement.get('valueDate'),
            ]);
        }
        return movementId;
    }

    handlePersoneticsEvents(data) {
        const {
            requestAccountTransactions,
            setPersoneticsCardMovementRequest,
            setPersoneticsAccountMovementRequest,
            setPersoneticsEmitedTransferMovementRequest,
            history,
            immInsightDetails,
        } = this.props;
        switch (data.requestString) {
            case 'sendRequestToPServer':
                const serverResponse =
                    immInsightDetails.get('success') &&
                    immInsightDetails.get('response');
                if (this.persoWidget.current !== null) {
                    serverResponse &&
                        serverResponse.size !== 0 &&
                        this.persoWidget.current.handleServerResponse(
                            serverResponse.toJS(),
                            data.json.requestId
                        );
                    this.widgetConfig.insightId = immInsightDetails.get(
                        'insightId'
                    );
                }
                break;

            case 'navigateToPage':
                if (
                    data.json.requestData.data.hasOwnProperty('navigateTarget')
                ) {
                    const navigateTarget =
                        data.json.requestData.data.navigateTarget;
                    let accountId = null;
                    let cardId = null;
                    if (data.json.requestData.data.payload) {
                        const navigationData = {
                            amount: data.json.requestData.data.payload.amount,
                            contractNumber:
                                data.json.requestData.data.payload
                                    .contractNumber,
                            date: data.json.requestData.data.payload.date,
                            description:
                                data.json.requestData.data.payload.description,
                            product: data.json.requestData.data.payload.product,
                        };
                        accountId = this.getAccountId(navigationData);
                        cardId = this.getCardId(navigationData);
                        let movementId = null;

                        this.setState({
                            accountId,
                            cardId,
                            movementId,
                            navigateTarget,
                            navigationData,
                        });
                        switch (navigateTarget) {
                            case ACCOUNT_DEFER_PAYMENT_NAVIGATION:
                                requestAccountTransactions(accountId);
                                break;

                            case CARD_MOVEMENT_NAVIGATION:
                                setPersoneticsCardMovementRequest(
                                    navigationData
                                );
                                break;

                            case ACCOUNT_MOVEMENT_NAVIGATION:
                                setPersoneticsAccountMovementRequest(
                                    navigationData
                                );
                                break;

                            case EMITED_TRANSFER_MOVEMENT_NAVIGATION:
                                setPersoneticsEmitedTransferMovementRequest(
                                    navigationData
                                );
                                break;

                            default:
                                break;
                        }
                    }

                    const isOpenInNewTab = NEW_TAB_CTA_LINKS.includes(
                        navigateTarget
                    );

                    if (navigateTarget !== ACCOUNT_DEFER_PAYMENT_NAVIGATION) {
                        PersoneticsNavigation.getNavigation(
                            navigateTarget,
                            accountId,
                            cardId,
                            null,
                            history,
                            isOpenInNewTab
                        );
                    }
                }
                break;

            case 'personeticsEvent':
                this.handleEventsTagging(
                    data.json.requestData.data.eventData,
                    immInsightDetails.get('insightId')
                );
                break;
        }
    }
    getCurrentProduct(id) {
        const { immInboxInsights, unread } = this.props;

        const insights = unread
            ? immInboxInsights
            : immInboxInsights.get('inboxInsights');
        const currentProductDetails = [];
        insights.map((insight, key) => {
            const insightStatus = insight.get('status');
            const teaserid = insight.get('id');

            const title = insight.get('teaserBlocks').find((teaser) => {
                return teaser.get('blockId') === 'title';
            });
            const isExpanded = this.state.expandedId === teaserid;
            currentProductDetails.push({
                teaser_id: teaserid,
                tealium_event: 'product_click',
                product_name: title.get('text'),
                product_id: title.get('text'),
                product_category: insightStatus,
                product_variant: isExpanded ? 'open':'close',
                product_position: key + 1,
            });
        });

        return currentProductDetails.filter((currentProduct) => {
            return currentProduct.teaser_id === id;
        });
    }
    getAllProductDetails() {
        const allProductDetails = [];
        const productTitle = [];
        const productInsightStatus = [];
        const productIsExpandedStatus = [];
        const productIndex = [];
        const personeicsInbox = [];
        const { immInboxInsights, unread } = this.props;

        const insights = unread
            ? immInboxInsights
            : immInboxInsights.get('inboxInsights');
        insights.map((insight, key) => {
            const insightStatus = insight.get('status');
            const teaserid = insight.get('id');
            const title = insight.get('teaserBlocks').find((teaser) => {
                return teaser.get('blockId') === 'title';
            });
        const isExpanded =
                this.state.expandedId === teaserid ? 'opened' : 'closed';
            productTitle.push(title.get('text'));
            productInsightStatus.push(insightStatus);
            productIsExpandedStatus.push(isExpanded);
            productIndex.push(key + 1);
            personeicsInbox.push(['personetics-inbox']);
        });
        allProductDetails.push({
            tealium_event: 'product_impression',
            product_impression_id: productTitle,
            product_impression_name: productTitle,
            product_impression_list: personeicsInbox,
            product_impression_category: productInsightStatus,
            product_impression_variant: productIsExpandedStatus,
            product_impression_position: productIndex,
        });
        return allProductDetails[0];
    }
    render() {
        const {
            assetsBaseUrl,
            immInboxInsights,
            immInsightDetails,
            unread,
        } = this.props;
        const insights = unread
            ? immInboxInsights
            : immInboxInsights.get('inboxInsights');

        const richTeaserContent = insights.map((insight, key) => {
            let teaserType;
            const insightStatus = insight.get('status');
            const isDateEmphasis = insightStatus !== 'read';
            const teaserTemplate = insight.get('teaserTemplate');
            const title = insight.get('teaserBlocks').find((teaser) => {
                return teaser.get('blockId') === 'title';
            });
            const generatedDateData = insight
                .get('teaserBlocks')
                .find((teaser) => {
                    return teaser.get('blockId') === 'date';
                });
            const date = moment(generatedDateData, 'YYYY/MM/DD');
            const day = date.format('DD');
            const month = date.format('MMM').replace('.', '');
            const generatedDate = `${day} ${month}`;
            const description = insight.get('teaserBlocks').find((teaser) => {
                return teaser.get('blockId') === 'teaser-text';
            });
            const image = insight.get('teaserBlocks').find((teaser) => {
                return teaser.get('blockId') === 'main-image';
            });
            const richTeaserClass = classnames('personetics-rich-teaser', {
                'personetics-rich-teaser__read': isDateEmphasis,
            });

            const teaserid = insight.get('id');

            switch (teaserTemplate) {
                case 'doubleBox':
                    const value1 = insight
                        .get('teaserBlocks')
                        .find(
                            (immTeaser) =>
                                immTeaser.get('blockId') === 'box-value1'
                        );
                    const label1 = insight
                        .get('teaserBlocks')
                        .find(
                            (immTeaser) =>
                                immTeaser.get('blockId') === 'box-label1'
                        );
                    const value2 = insight
                        .get('teaserBlocks')
                        .find(
                            (immTeaser) =>
                                immTeaser.get('blockId') === 'box-value2'
                        );
                    const label2 = insight
                        .get('teaserBlocks')
                        .find(
                            (immTeaser) =>
                                immTeaser.get('blockId') === 'box-label2'
                        );
                    teaserType = (
                        <div className='personetics-rich-teaser__double-box col-xs-7'>
                            <span className='personetics-rich-teaser__value-one'>
                                {value1.get('text')}
                                <p>{label1.get('text')}</p>
                            </span>
                            <span className='personetics-rich-teaser__value-two'>
                                {value2.get('text')}
                                <p>{label2.get('text')}</p>
                            </span>
                        </div>
                    );
                    break;
                case 'image':
                    const imageURL = `${assetsBaseUrl}/web/${image.get(
                        'url'
                    )}.png`;
                    const imageAlt = image.get('alt');
                    teaserType = (
                        <div className='personetics-rich-teaser__image-container col-xs-7'>
                            <img
                                src={imageURL}
                                alt={imageAlt}
                                className='personetics-rich-teaser__image'
                            />
                        </div>
                    );
                    break;
                case 'verticalBar':
                    const verticalBar = insight
                        .get('teaserBlocks')
                        .find(
                            (immTeaser) => immTeaser.get('blockId') === 'chart'
                        );
                    teaserType = (
                        <div className='personetics-rich-teaser__bar-chart col-xs-7'>
                            <PersoneticsBarChart
                                data={verticalBar}
                                barSize={15}
                            />
                        </div>
                    );
                    break;
                case 'horizontalBar':
                    const horizontalBar = insight
                        .get('teaserBlocks')
                        .find(
                            (immTeaser) => immTeaser.get('blockId') === 'chart'
                        );
                    teaserType = (
                        <div className='personetics-rich-teaser__horizontal-bar-chart col-xs-7'>
                            <PersoneticsHorizontalBarChart
                                dataObject={horizontalBar}
                                barSize={15}
                            />
                        </div>
                    );
                    break;
                case 'pinChart':
                    const pinChart = insight
                        .get('teaserBlocks')
                        .find(
                            (immTeaser) => immTeaser.get('blockId') === 'chart'
                        );
                    teaserType = (
                        <div className='personetics-rich-teaser__pin-chart col-xs-7'>
                            <PersoneticsPinChart
                                dataObject={pinChart}
                                barSize={15}
                            />
                        </div>
                    );
                    break;
                case 'pie':
                    teaserType = (
                        <div className='personetics-rich-teaser__pie-chart col-xs-7'>
                            <PersoneticsPieChart insight={insight} />
                        </div>
                    );
                    break;
                case 'lineChart':
                    const lineChart = insight
                        .get('teaserBlocks')
                        .find(
                            (immTeaser) => immTeaser.get('blockId') === 'chart'
                        );
                    teaserType = (
                        <div className='personetics-rich-teaser__pie-chart col-xs-7'>
                            <PersoneticsLineChart
                                immLineChartData={lineChart}
                            />
                        </div>
                    );
            }
            let stories;
            if (immInsightDetails) {
                if (immInsightDetails.get('isFetching')) {
                    stories = <LoadingSection />;
                } else if (immInsightDetails.get('success')) {
                    stories = (
                        <div>
                            <PersoneticsWidget
                                ref={this.persoWidget}
                                config={this.state.widgetConfig}
                            />
                        </div>
                    );
                } else if (immInsightDetails.get('error')) {
                    const retryButton = (
                        <OKButton
                            onClick={() => this.handleOnClick(true, teaserid)}
                        >
                            <FormattedText value='common-retry' />
                        </OKButton>
                    );
                    stories = (
                        <div className='personetics-rich-teaser__empty-state'>
                            <EmptyState
                                primaryText={formatText(
                                    'personetics-personetics_connectionError'
                                )}
                                button={retryButton}
                                iconType='nointernet-banking'
                            />
                        </div>
                    );
                }
            }
            let accordionHeaderContent;

            const isExpanded = this.state.expandedId === teaserid;
            const showHeader = !isExpanded;
            if (showHeader) {
                accordionHeaderContent = (
                    <div id={`acc_header_${teaserid}`}>
                        <div className='personetics-rich-teaser__header col-xs-12'>
                            <div className='personetics-rich-teaser__title col-xs-8'>
                                {title.get('text')}
                            </div>
                            <div className='personetics-rich-teaser__date col-xs-4'>
                                <OKTag
                                    content={generatedDate.toUpperCase()}
                                    type='informative'
                                    context='pill'
                                    emphasis={isDateEmphasis}
                                />
                            </div>
                        </div>
                        <div className='col-xs-12'>
                            <div className='personetics-rich-teaser__content  row'>
                                <div className='personetics-rich-teaser__description col-xs-5'>
                                    {description.get('text')}
                                </div>
                                {teaserType}
                            </div>
                        </div>
                    </div>
                );
            }

            return (
                <div key={key} className={richTeaserClass}>
                    <Accordion
                        id={teaserid}
                        onClick={this.handleOnClick}
                        isExpanded={isExpanded}
                        allowSingleExpand={true}
                    >
                        <AccordionHeader
                            name='AccordionHeader'
                            canBeExpanded={true}
                            toggleAccordianContent
                        >
                            {accordionHeaderContent}
                        </AccordionHeader>
                        <AccordionBody name='AccordionBody'>
                            {stories}
                        </AccordionBody>
                    </Accordion>
                </div>
            );
        });

        return <div>{richTeaserContent}</div>;
    }
}

PersoneticsRichTeaser.defaultProps = {
    unread: false,
};

PersoneticsRichTeaser.propTypes = {
    assetsBaseUrl: PropTypes.string.isRequired,
    clickedId: PropTypes.string,
    getPersoneticsInsightDetails: PropTypes.func.isRequired,
    history: PropTypes.object.isRequired,
    immAccounts: PropTypes.object.isRequired,
    immCards: PropTypes.object.isRequired,
    immInboxInsights: PropTypes.object.isRequired,
    immInsightDetails: PropTypes.object.isRequired,
    immInsights: PropTypes.object.isRequired,
    immTransaction: PropTypes.object.isRequired,
    requestAccountTransactions: PropTypes.func.isRequired,
    setPersoneticsCardMovementRequest: PropTypes.func.isRequired,
    setPersoneticsAccountMovementRequest: PropTypes.func.isRequired,
    setPersoneticsEmitedTransferMovementRequest: PropTypes.func.isRequired,
    unread: PropTypes.bool.isRequired,
};

module.exports.constructor = PersoneticsRichTeaser;

module.exports.PersoneticsRichTeaser = connect(
    (state) => ({
        immAccounts: state.accounts,
        immCards: state.cards,
        immTransaction: state.accountsTransactions,
    }),
    {
        requestAccountTransactions:
            accountsTransactionsActions.requestAccountTransactions,
    }
)(withRouter(PersoneticsRichTeaser));
